import script from "./CourseNew.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseNew.vue?vue&type=script&setup=true&lang=js"

import "./CourseNew.vue?vue&type=style&index=0&id=af962b96&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af962b96"]])

export default __exports__